
import React, { Component } from 'react';
import cIf from 'classnames';
import type { PackageInfoModel } from "../../../mvcapi/models/common/package-info-model";
import { PackageEventSelection, SaleMessagesInfo } from '../../organisms/buypackages';
import { PromoPasswordInputPanel } from '../../organisms/promotions';
import { TicketPriceSelection } from '../../organisms/selectprices';
import { TicketSelectionUnrestricted } from '../../organisms/buytickets/ticket-selection-unrestricted';
import { IFrameContext, IFrameContextClass } from '../../../logic/reactcontext/iframe-context';
import { LiteShopProductOverview } from '../../molecules/buytickets/lite-shop-product-overview';
import { SiteCustomizationClass, SiteCustomizationContext } from '../../../logic/reactcontext/site-customization-context';
import { concat, map } from 'lodash';
import { AddPackageToCartStoreExt, useAddPackageToCartStoreExt } from '../../../stores/add-to-cart-stores/add-package-to-cart-store-ext';
import { AddTicketsToCartStore, useAddTicketsToCartStore } from '../../../stores';
import { getPackagePresaleInfoByKey } from '../../../mvcapi/buy-ticket-api';
import { BuyPackagePromoInfoModel } from '../../../mvcapi/models/buypackage/buy-package-promo-info-model';
import { SiteInfoModel } from '../../../tsrestapi/models/site-info-model';
import { getHidePackageEventDetailLinksSetting, getSiteInfo } from '../../../tsrestapi/site-info';
import { StateWatcher } from '../../../stores/store-utils';

// Uses window.tsapp
const ctl = tsapp.ctl;
const PleaseWaitSpinner = ctl.utilctl.PleaseWaitSpinner;
const tsRest = require('ts-rest-client');
const PageSection = ctl.utilctl.PageSection;
const PlaceToGoEnum = ctl.utilctl.PlaceToGoEnum;
// const tr = require('ts-translate-js').default.boundTR;

const RCOMBRIDGE_getURLToClientSite = ctl.utilctl.RCOMBRIDGE_getURLToClientSite;
const RCOMBRIDGE_getClientSiteURLParams = ctl.utilctl.RCOMBRIDGE_getClientSiteURLParams;

const testIFrameCookieSecurityIssue = ctl.utilctl.testIFrameCookieSecurityIssue;
const CookieSecurityWarningPanel = ctl.utilctl.CookieSecurityWarningPanel;
const retrieveIFramePosition = ctl.utilctl.retrieveIFramePosition;


// var getMomentTZDateTime = require('ts-util').getMomentTZDateTime;

const steps = [
    'SELECTDATE',
    'SELECTTICKET',
    'SELECTPRICE'
];


const _ThresholdMinSite = 400;

export type BuyPackageOnePagerWidgetProps = {
    packageID: number,
    rstprv: string,
    homeUrl: string,
    cookiesverified: boolean,
    onContentChange: () => void,
    onBuyClick: () => void,
    continueShoppingUrl: string,
    ticketQtySelectionSection: any,
};

type BuyPackageOnePagerWidgetState = {
    // From store
    loadingPackageInfo: boolean,
    packageID: number,
    packageinfo: PackageInfoModel,
    selectedEventDateIDs: number[],

    // Regular
    currentStep: string,
    promoInfo: BuyPackagePromoInfoModel,
    loadingPromoInfo: boolean,
    siteInfo: SiteInfoModel,
    hidePackageEventDetailLink: boolean,
    iframeCookieIssue: boolean,
    urlClientSite: string,
    cookiesVerified: boolean,
    framePosition: { x: number, y: number },
    minHeight: number, // Used by the popup compensation system for IFrame resize. When a sub popup is bigger than the main app Div.
};

// TODO: TOTSAPP
export class BuyPackageOnePagerWidget extends Component<BuyPackageOnePagerWidgetProps, BuyPackageOnePagerWidgetState> {
    private packageInfosRequest: any;
    private loadPromoInfoRequest: any;
    private siteInfoProm: any;
    private hidePackageDetailProm: any;
    private iframeContext: IFrameContextClass;
    //private unsubsribes: (() => void)[] = [];
    private packageStoreWatcher = new StateWatcher<AddPackageToCartStoreExt, BuyPackageOnePagerWidgetState>(useAddPackageToCartStoreExt, this.setState.bind(this));
    private siteSettingsContext: SiteCustomizationClass;
    

    constructor(props) {
        super(props);

        this.state = {
            selectedEventDateIDs: [],
            packageID: 0,
            currentStep: 'SELECTDATE',
            loadingPackageInfo: false,
            packageinfo: null, // as PackageInfo
            hidePackageEventDetailLink:false,
            iframeCookieIssue: testIFrameCookieSecurityIssue(), // This is a check for Safari, IPhone, IPads because these browsers don't allow settings cookies when the user hasn't visited our main web site using no IFrame.
            promoInfo: undefined,
            loadingPromoInfo: false,
            siteInfo: undefined,
            urlClientSite: undefined,
            framePosition: undefined,
            cookiesVerified: false, // Doesn't seem to be used anywhere...
            minHeight: 0,
        };

        this.goToCart = this.goToCart.bind(this);
        this.goToCheckout = this.goToCheckout.bind(this);
        this.goToHome = this.goToHome.bind(this);
        this.handleEventDatesSelected = this.handleEventDatesSelected.bind(this);
        this.handleOnChangeEventDates = this.handleOnChangeEventDates.bind(this);
        this.handlePromoInfoUpdated = this.handlePromoInfoUpdated.bind(this);
        this.handlePromoUpdated = this.handlePromoUpdated.bind(this);
        this.afterGetPositionControl = this.afterGetPositionControl.bind(this);
        this.onProductAddedToCart = this.onProductAddedToCart.bind(this);
        this.handleReturnToTicketQtySelection = this.handleReturnToTicketQtySelection.bind(this);
        this.handleRefreshPackageForPromoUpdated = this.handleRefreshPackageForPromoUpdated.bind(this);
        this.minSizeRequested = this.minSizeRequested.bind(this);
    }

    // watchAddToCartState<T>(get: (s: AddTicketsToCartStore) => T, set: (val: T) => Partial<BuyPackageOnePagerWidgetState>) {
    //     this.unsubsribes.push(useAddTicketsToCartStore.subscribe(s => get(s), (val) => { this.setState(set(val) as any) }));
    // }

    // watchPackageExtState<T>(get: (s: AddPackageToCartStoreExt) => T, set: (val: T) => Partial<BuyPackageOnePagerWidgetState>) {
    //     this.unsubsribes.push(useAddPackageToCartStoreExt.subscribe(s => get(s), (val) => { this.setState(() => (set(val) as any)) }));
    // }

    // watchPackageExtState2(watchField: keyof AddPackageToCartStoreExt, localStateName: keyof BuyPackageOnePagerWidgetState) {
    //     this.unsubsribes.push(useAddPackageToCartStoreExt.subscribe(
    //         s => s[watchField], // Watch
    //         (val) => { 
    //             this.setState((prev) => ({...prev, [localStateName]: val })); // Apply in local state
    //         })
    //     );
    // }

    componentDidMount() {
        this.packageStoreWatcher.watch("packageId", "packageID");
        this.packageStoreWatcher.watch("package", "packageinfo");
        this.packageStoreWatcher.watch("loadingPackage", "loadingPackageInfo");
        this.packageStoreWatcher.watch("selectedEventDateIds", "selectedEventDateIDs");

        useAddTicketsToCartStore.getState().setAfterAddedToCartCallback(this.onProductAddedToCart);
        useAddTicketsToCartStore.getState().setOnPromoUpdatedCallback(this.handlePromoUpdated);

        //this.watchPackageExtState(s => s.packageId, (v) => ({ packageID: v} ));
        // this.watchPackageExtState(s => s.package, (v) => ({ packageinfo: v} ));
        // this.watchPackageExtState(s => s.loadingPackage, (v) => ({ loadingPackageInfo: v} ));
        // this.watchPackageExtState(s => s.selectedEventDateIds, (v) => ({ selectedEventDateIDs: v} ));
        
        this.iframeContext = new IFrameContextClass();
        this.siteSettingsContext = new SiteCustomizationClass(tsapp.siteSettings);

        if(this.props.onContentChange) {
            this.iframeContext.onContentChanged(this.props.onContentChange);
            this.iframeContext.onMinSizeChanged(this.minSizeRequested);
        }

        //RCOMBRIDGE_copyTrackingCookies();
        this.setCookiesVerified();
        
        if(this.props.rstprv != null && this.props.rstprv.length > 0)
            this.loadPromoInfo();

        if(this.props.packageID != null) {
            //this.setState({ packageID: this.props.packageID });
            this.loadPackageInfos(this.props.packageID);
        }
        
        retrieveIFramePosition("sticky-menu", this.setIFramePosition);

        this.loadSiteInformation();
        this.loadHidePackageEventDetailLinkSetting();

        this.raiseContentChanged();
    }

    componentDidUpdate(_prevProps: BuyPackageOnePagerWidgetProps, prevState: BuyPackageOnePagerWidgetState) {

        // Sert à passer la l'étape de sélection des billets et des tarifs quand c'est un forfait fixe
        if(this.state.packageinfo && this.state.packageinfo.Use2024UnrestrictedSale && this.state.packageinfo != prevState.packageinfo && this.state.packageinfo.IsFixedPackage)
            this.handleEventDatesSelected();

        this.raiseContentChanged(); // TODO : Devrait peut etre juste être triggered dans la fin du render avec un setTimeout....
    }

    componentWillUnmount() {
        //this.unsubsribes.forEach(unsub => unsub());
        this.packageStoreWatcher.unsubscribeAll();

        if(this.packageInfosRequest) this.packageInfosRequest.abort();
        if(this.loadPromoInfoRequest) this.loadPromoInfoRequest.abort();
        if(this.siteInfoProm) this.siteInfoProm.abort();

        if(this.hidePackageDetailProm) this.hidePackageDetailProm.abort();
        if(this.props.onContentChange) {
            this.iframeContext.offContentChanged(this.props.onContentChange);
            this.iframeContext.offMinSizeChanged(this.minSizeRequested);
        }
    }

    minSizeRequested(width: number, height: number) { 
        if(height != this.state.minHeight) // Very important to prevent infinite react loop 
            this.setState({ minHeight: height }); 
    }
    
    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    }

    setIFramePosition(pos) {
        if(this.state.framePosition == null || this.state.framePosition.x != pos.x || this.state.framePosition.y != pos.y)
            this.setState({ framePosition: { x: pos.x, y: pos.y } });
    }

    afterGetPositionControl(pos) {
        if (window.scrollParentTo && this.state.framePosition != null && $(window).width() < _ThresholdMinSite){
            window.scrollParentTo(this.state.framePosition.x, this.state.framePosition.y + pos.y);
        }
    }

    setUrlClientSite() {
        RCOMBRIDGE_getURLToClientSite((url) => this.setState({ urlClientSite: url}));
    }
    
    getUrlParams(params) {
        const cookiesVerified = params["cookiesverified"] === "true";
        if(this.state.cookiesVerified !== cookiesVerified)
            this.setState({ cookiesVerified: cookiesVerified }); // TODO: Doesn't seem to be used anywhere...
    }
    
    setCookiesVerified() {
        this.setUrlClientSite();
        RCOMBRIDGE_getClientSiteURLParams(this.getUrlParams);
    }

    handleReturnToTicketQtySelection () {
        this.setState({ currentStep:"SELECTDATE" });
    }

    handleEventDatesSelected() {
        this.setState({ currentStep:"SELECTPRICE" });
    }

    handleOnChangeEventDates(selectedIDs: number[]) {
        useAddPackageToCartStoreExt.getState().setSelectedEventDateIds(selectedIDs);
        //this.setState({ selectedEventDateIDs: selectedIDs });
    }


    handlePromoUpdated() {
        if(this.props.packageID != null) {
            this.loadPackageInfos(this.props.packageID);
        }
    }

    onProductAddedToCart(placeToGo: string) {
        switch(placeToGo) {
            case PlaceToGoEnum.CONTINUE_SHOPPING:
                this.goToHome();
                break;
            case PlaceToGoEnum.GO_TO_CHECKOUT:
                this.goToCheckout();
                break;
            case PlaceToGoEnum.GO_TO_CART:
                this.goToCart();
                break;
        }
    }

    goToCart() {
        tsapp.goToCart(this.siteSettingsContext?.siteSettings.integ);
    }

    goToCheckout() {
        tsapp.goToCheckout(this.siteSettingsContext?.siteSettings.integ); 
    }

    goToHome() {
        tsapp.goToHome(this.siteSettingsContext?.siteSettings.integ, this.props.continueShoppingUrl);
    }

    // Load ProgramInfos by ID
    loadPackageInfos(packageID) {

        useAddPackageToCartStoreExt.getState().loadPackage(packageID);


        // this.setState({ loadingPackageInfo: true });

        // this.packageInfosRequest = tsapp.mvcapi.postCtl("buypackage/packageinfos", { packageID: packageID })
        //                                 .success(function(data) {
        //                                     const pkg: PackageInfoModel = data.PackageInfo;
        //                                     if (data.PackageInfo.IsFixedPackage) { // si c'est un forfait fixe on s�lectionne automatiquement tous les �v�nements
        //                                         var selectedEventDateIDs = _.concat(_.map(pkg.MandatoryEventDateInfos, (eventDate) => eventDate.EventDateID),
        //                                                                             _.map(pkg.EventDateInfos, (eventDate) => eventDate.EventDateID));

        //                                         this.setState({ packageID: packageID, selectedEventDateIDs: selectedEventDateIDs });
        //                                     }
                                            
        //                                     this.setState({ packageinfo:data.PackageInfo, loadingPackageInfo: false });
        //                                 }.bind(this));

    }

    async loadPromoInfo() {
        this.setState({ loadingPromoInfo: true });

        const promoInfo = await getPackagePresaleInfoByKey(this.props.rstprv);
        this.handlePromoInfoUpdated(promoInfo);

        // this.loadPromoInfoRequest = tsapp.mvcapi.postCtl("buypackage/promoinfo", { rstprv: this.props.rstprv })
        //                                     .success((data) => this.handlePromoInfoUpdated(data.promoInfo));
    }

    
    handlePromoInfoUpdated(promoInfo: BuyPackagePromoInfoModel) {
        
        this.raiseContentChanged();
        this.setState({
            promoInfo: promoInfo,
            //packageID: promoInfo.packageID,
            loadingPromoInfo: false
        });

        useAddPackageToCartStoreExt.getState().setPackageId(promoInfo.packageID);

        // If password ok, we can load the package
        if(!promoInfo.passwordNeeded) {

            this.loadPackageInfos(promoInfo.packageID);
            // TODO Trigger the load of the package
        }
    }

    handleRefreshPackageForPromoUpdated() {
        if (this.props.packageID != null)
            this.loadPackageInfos(this.props.packageID);
    }

    async loadSiteInformation(){
        const siteInfo = await getSiteInfo(this.siteSettingsContext?.siteSettings.integ);
        this.setState({ siteInfo });
    }

    async loadHidePackageEventDetailLinkSetting(){
        const hidePackageEventDetailLink = await getHidePackageEventDetailLinksSetting(this.siteSettingsContext?.siteSettings.integ);
        this.setState({ hidePackageEventDetailLink });
    }

    render() {
        const processing = (this.state.packageID != null && this.state.loadingPackageInfo)
                        || (this.props.rstprv != null && this.state.loadingPromoInfo);

        // Promo code password input
        const isInPromoMode = this.state.promoInfo != null;
        const promoPasswordNeeded = isInPromoMode && this.state.promoInfo.passwordNeeded;


        // Section - Please wait initial
        // var pleaseWaitMessage =
        //     (
        //         processing
        //     ) ? (
        //         <PageSection>
        //             <PleaseWaitSpinner size="md" />
        //         </PageSection>
        //     )
        //     : null;

        
        // var hiddenPromo = (this.props.rstprv != null && this.props.rstprv != "");

        // if(isInPromoMode && !this.state.iframeCookieIssue) { // We don't want to ask for a password if the cookies are not activated. It'll just crash if we do so.

            
        //     var promoSection =
        //         <PageSection afterGetPosition={this.afterGetPositionControl} sectionDone={!promoPasswordNeeded}>
        //             <PromoPasswordInputPanel
        //                 key="promoPasswordInputPanel"
        //                 promoInfo={this.state.promoInfo}
        //                 onPromoInfoUpdated={this.handlePromoInfoUpdated}
        //                 onContentChange={this.props.onContentChange}
        //             />
        //         </PageSection>;
        // } 
        
        // var ticketPriceSelection = null;
        
        // if(steps.indexOf(this.state.currentStep) > steps.indexOf("SELECTTICKET"))
        //     ticketPriceSelection =
        //         <PageSection afterGetPosition={this.afterGetPositionControl}>
        //             <TicketPriceSelection packageID={this.state.packageID}
        //                                                     packageInfo={this.state.packageinfo}
        //                                                     integ={this.siteSettingsContext?.siteSettings.integ}
        //                                                     eventDateIDs={useAddPackageToCartStoreExt.getState().selectedEventDateIds}
        //                                                     onContentChange={this.props.onContentChange}
        //                                                     onProductAddedToCart={this.onProductAddedToCart}>
        //             </TicketPriceSelection>
        //         </PageSection>;

        let packageSection = null;
        // var packageOverview = null;
        let showPackageOverview = false;
        let showSaleMessage = false;
        const showCookieWarning = this.state.iframeCookieIssue && this.state.siteInfo != null && this.state.urlClientSite != null;


        // ifthis.siteSettingsContext?.siteSettings.integ(showCookieWarning) { // Condition pour Affichage de l'activation des cookies
        //     packageSection = (
        //         <PageSection afterGetPosition={this.afterGetPositionControl}>
        //             <CookieSecurityWarningPanel
        //                 cookiesverified={this.props.cookiesverified}
        //                 tsSiteDomain="https://www.reservatech.net"
        //                 siteInfo={this.state.siteInfo}
        //                 urlClientSite={this.state.urlClientSite}
        //             />
        //         </PageSection>
        //     ); // Unhardcode this someday...
        // } else 
        if(!showCookieWarning && this.state.packageID != null && this.state.packageinfo != null) {
            
            if(this.state.packageinfo.IsPackageInSale) {
                showPackageOverview = tsapp.isLiteShop; // Display this if we are in a light shop
                
                // packageOverview = tsapp.isLiteShop && <LiteShopProductOverview
                //                 pictureThumbnailURL={this.state.packageinfo.MediaInfo.PictureThumbnailURL}
                //                 productName={this.state.packageinfo.Name}
                //                 productDescription={this.state.packageinfo.Description}
                //                 venueName={this.state.packageinfo.physicalVenuName}
                //             />

                // Prioritize package's HideEventDetailLinks setting over current integ's one
                const hidePackageEventDetailLink = this.state.packageinfo.HideEventDetailLinks || this.state.hidePackageEventDetailLink;
                packageSection = (
                    <PageSection sectionDone={steps.indexOf(this.state.currentStep) > steps.indexOf("SELECTDATE")} afterGetPosition={this.afterGetPositionControl}>
                        <div className="row">
                            <div className="col-xs-12">
                                <PackageEventSelection packageInfo={this.state.packageinfo}
                                                        selectedEventDateIDs={useAddPackageToCartStoreExt.getState().selectedEventDateIds}
                                                        overview={steps.indexOf(this.state.currentStep) > steps.indexOf("SELECTDATE")}
                                                        hidePackageEventDetailLink={hidePackageEventDetailLink}
                                                        onContentChange={this.props.onContentChange}
                                                        homeUrl={this.props.homeUrl}
                                                        onBuyClick={this.props.onBuyClick}
                                                        onChangeEventDates={this.handleOnChangeEventDates}
                                                        handleStepDone={this.handleEventDatesSelected}
                                                        onPromoInfoUpdated={this.handleRefreshPackageForPromoUpdated}
                                                        onModifyThisStep={this.handleReturnToTicketQtySelection}>
                                </PackageEventSelection>
                            </div>
                        </div>
                    </PageSection>);
            }
            else
                showSaleMessage = true;
            //} else if(!this.state.packageinfo.IsPackageInSale || this.state.packageinfo.IsPackageSoldOut) {
                //showSaleMessage = true;
                // packageSection = (
                //     <PageSection sectionDone={false}>
                //         <div className="col-xs-12 col-sm-offset-2 col-sm-8">
                //             <SaleMessagesInfo packageInfo={this.state.packageinfo}></SaleMessagesInfo>
                //         </div>
                //     </PageSection>
                // );
            //}
        }

        const mainDivStyle = { minHeight: this.state.minHeight };

        return <SiteCustomizationContext.Provider value={this.siteSettingsContext}>
            <IFrameContext.Provider value={this.iframeContext}>
                <div className={cIf(this.siteSettingsContext?.siteSettings.integ)} style={mainDivStyle}>
                {(isInPromoMode && !this.state.iframeCookieIssue) && <PageSection afterGetPosition={this.afterGetPositionControl} sectionDone={!promoPasswordNeeded}>
                    <PromoPasswordInputPanel
                        key="promoPasswordInputPanel"
                        promoInfo={this.state.promoInfo}
                        onPromoInfoUpdated={this.handlePromoInfoUpdated}
                        onContentChange={this.props.onContentChange}
                    />
                </PageSection>}

                {processing && <PageSection>
                    <PleaseWaitSpinner size="md" />
                </PageSection>}

                {showPackageOverview && <LiteShopProductOverview
                    pictureThumbnailURL={this.state.packageinfo.MediaInfo.PictureThumbnailURL}
                    productName={this.state.packageinfo.Name}
                    productDescription={this.state.packageinfo.Description}
                    venueName={this.state.packageinfo.physicalVenuName}
                />}

                {showCookieWarning && <PageSection afterGetPosition={this.afterGetPositionControl}>
                    <CookieSecurityWarningPanel
                        cookiesverified={this.props.cookiesverified}
                        tsSiteDomain="https://www.reservatech.net"
                        siteInfo={this.state.siteInfo}
                        urlClientSite={this.state.urlClientSite}
                    />
                </PageSection>}

                {showSaleMessage && <PageSection sectionDone={false}>
                    <div className="col-xs-12 col-sm-offset-2 col-sm-8">
                        <SaleMessagesInfo packageInfo={this.state.packageinfo}></SaleMessagesInfo>
                    </div>
                </PageSection>}

                {packageSection}

                {steps.indexOf(this.state.currentStep) > steps.indexOf("SELECTTICKET") && <PageSection afterGetPosition={this.afterGetPositionControl}>

                    {this.state.packageinfo.Use2024UnrestrictedSale

                    ? !showSaleMessage && <TicketSelectionUnrestricted />

                    : <TicketPriceSelection 
                            packageID={this.state.packageID}
                            packageInfo={this.state.packageinfo}
                            integ={this.siteSettingsContext?.siteSettings.integ}
                            eventDateIDs={useAddPackageToCartStoreExt.getState().selectedEventDateIds}
                            onContentChange={this.props.onContentChange}
                            onProductAddedToCart={this.onProductAddedToCart}>
                    </TicketPriceSelection>}
                    
                </PageSection>}
                </div>
            </IFrameContext.Provider>
        </SiteCustomizationContext.Provider>;
    }
}

